class SearchInput extends HTMLElement {
  connectedCallback() {
    // Get elements
    this.searchInput = this.querySelector('input[type="search"]');
    this.machineFilter = this.querySelector('[data-machine-filter]');

    // Get machine controller
    this.machineController = window.getMachineController?.();

    // Set initial machine filter value
    if (this.machineFilter && this.machineController) {
      const currentState = this.machineController.getCurrentState();
      this.machineFilter.value = currentState.modelGid || '';
    }

    // Subscribe to machine changes
    if (this.machineController) {
      this.unsubscribeMachineChange = subscribe('machine:change', (machineData) => {
        this.updateMachineFilter(machineData);
      });
    }

    // Handle search input
    this.searchInput.addEventListener('input', () => {
      this.publishEvent('search:input');
      this.toggleClearButton();
    });

    // Handle search clear
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-search-clear]')) {
        this.clearSearchInput();
      }
    });
  }

  disconnectedCallback() {
    if (this.unsubscribeMachineChange) {
      this.unsubscribeMachineChange();
    }
  }

  /**
   * Update machine filter value
   * @param {Object} machineData - Machine data from controller
   */
  updateMachineFilter(machineData) {
    if (this.machineFilter) {
      this.machineFilter.value = machineData.modelGid || '';
    }
  }

  /**
   * Clear the search input
   */
  clearSearchInput() {
    this.searchInput.value = '';
    this.publishEvent('search:clear');
    this.toggleClearButton();
    this.searchInput.focus();
  }

  /**
   * Publish the event
   */
  publishEvent(eventName) {
    publish(`${eventName}:${this.id}`, {
      target: this.id,
      value: this.searchInput.value,
    });
  }

  /**
   * Toggle the clear button
   */
  toggleClearButton() {
    this.querySelector('[data-search-clear]').ariaHidden = this.searchInput.value.length === 0;
  }
}

customElements.define('search-input', SearchInput);
